module.exports = __webpack_public_path__ + "img/Brake master cylinder.172bc040.jpg";